module.exports = __webpack_public_path__ + "static/assets/011297ca060699e09d9245235f10fe21.gif";